// Warm, tactile, production and materials focused. No runway or model imagery.
export const IMG = {
  hero: "https://images.unsplash.com/photo-1705493254146-710211d851fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  linen: "https://images.unsplash.com/photo-1528458909336-e7a0adfed0a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  linenFolds: "https://images.unsplash.com/photo-1634665810235-011d663754e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  tailor: "https://images.pexels.com/photos/6766297/pexels-photo-6766297.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  studio: "https://images.unsplash.com/photo-1753162657464-7f829c766d54?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  sewing: "https://images.unsplash.com/photo-1606501126768-b78d4569d3f9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  rackWarm: "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  rackJackets: "https://images.unsplash.com/photo-1551488831-00ddcb6c6bd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  patterns: "https://images.unsplash.com/photo-1687226480336-8e5c1b34faf5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

// Per-country hero image
export const COUNTRY_IMG = {
  india: IMG.tailor,
  china: IMG.sewing,
  bangladesh: IMG.rackJackets,
  vietnam: IMG.patterns,
  turkey: IMG.rackWarm,
};

// Per-service image
export const SERVICE_IMG = {
  "costing-pricing-and-margin": IMG.linen,
  "supplier-and-factory-sourcing": IMG.hero,
  "range-and-buy-planning": IMG.rackJackets,
  "product-development-and-quality": IMG.patterns,
  "inventory-markdown-and-cash": IMG.rackWarm,
  "launch-plan-for-new-brands": IMG.studio,
  "accessories-and-jewellery-sourcing": IMG.linenFolds,
};
